import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';


@Component({
  selector: 'app-custom-registeration',
  templateUrl: './custom-registeration.component.html',
  styleUrls: ['./custom-registeration.component.scss']
})
export class CustomRegisterationComponent implements OnInit {
  isMultiplePatient:boolean = false;
  isPasswordEntered:boolean = false;
  mobileNumberValue:string='';
  patientCodeValue:string='';
  passwordValue:string='';
  queueId:number = null;
  isLoading:boolean=false;
  callCenterPhoneNumber:string='';
  whatsAppMessageURL:string='';
  constructor(private helperService:HttphelperService,private messageService:MessageService) { 
    this.callCenterPhoneNumber = ConfigService.APPMainsettings.CallCenterPhoneNumber;
    this.whatsAppMessageURL = ConfigService.APPMainsettings.whatsAppMessageURL;
  }

  ngOnInit(): void {
  }
  validateMobileNum():void
  { 
    this.isMultiplePatient = false;
    this.isPasswordEntered = false;
    this.queueId = null;
    if(this.mobileNumberValue == null || this.mobileNumberValue == ''){
      this.messageService.add({severity: 'warn', summary: 'Warn', detail:'Please enter mobile number first', life: 2000});
      return;
    }
    var url = "/api/Account/ValidateMobileNum";
    var model : any= {MobileNumber : this.mobileNumberValue};
    this.isLoading = true;
    this.helperService.postRequest(url,false,model).subscribe(response =>
    {
      if(response.Success)
      {
        this.messageService.add({severity: 'success', summary: 'success', detail:response.Message, life: 2000});
        this.isPasswordEntered = true;
        this.queueId = response.Id;
      }
      else
      {
        var data = response.Data;
        if(data.IsMultiple)
        {
          this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
          this.isMultiplePatient = true;
        }
        else
        {
          this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
        }
      }   
      this.isLoading = false;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
  validatePatientCode():void{
    if(this.patientCodeValue == null || this.patientCodeValue == ''){
      this.messageService.add({severity: 'warn', summary: 'Warn', detail:'Please enter patient code first', life: 2000});
      return;
    }
    var url = "/api/Account/ValidatePatientCode";
    var model : any = {PatientCode : this.patientCodeValue,MobileNumber : this.mobileNumberValue};
    this.isLoading = true;
    this.helperService.postRequest(url,false,model).subscribe(response =>
    {
      if(response.Success)
      {
        this.messageService.add({severity: 'success', summary: 'success', detail:response.Message, life: 2000});
        this.isMultiplePatient = false;
        this.isPasswordEntered = true;
        this.queueId = response.Id;
      }
      else
      {
        this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
  ValidatePassword():void{
    if(this.passwordValue == null || this.passwordValue == ''){
      this.messageService.add({severity: 'warn', summary: 'Warn', detail:'Please enter password first', life: 2000});
      return;
    }
    var url = "/api/Account/ValidatePassword";
    var model : any = {Password : this.passwordValue,QueueId : this.queueId};
    this.isLoading = true;
    this.helperService.postRequest(url,false,model).subscribe(response =>
    {
      if(response.Success)
      {
        this.messageService.add({severity: 'success', summary: 'Success', detail:response.Message, life: 2000});
        localStorage.setItem('token',response.Data.token);
        localStorage.setItem('patientName',response.Data.FullName);
        localStorage.setItem('gender',response.Data.GenderId);
        localStorage.setItem('PatientId',response.Data.PatientId);
        localStorage.setItem('Image',response.Data.Image);
        localStorage.setItem('lang',"en");
        if(response.Data.LanguageId == 1){
          localStorage.setItem('lang',"ar");
        }
        window.location.href = 'changepassword';
      }
      else
      {
        this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
  backToLogin(){
    window.location.href = 'customlogin';
  }
}
